export const CALENDLY_URL = 'https://calendly.com/synoro-ai/30min';
export const SITE_URL = 'https://go4profit.us';
export const COURSES_URL = 'https://www.synoro.academy/';

export const CONTACT = {
  email: 'info@go4profit.us',
  address: '1655 S Blue Island Ave #559, Chicago, IL 60608',
  addressLabel: 'Address',
  locationLine: 'Chicago area • Remote support across the United States',
  locationShort: 'Chicago area • Serving clients remotely across the United States',
  serving: 'Based in the Chicago area. Serving clients remotely across the United States.',
};

export const SOCIAL = [
  { id: 'maps', label: 'Google Maps', href: 'https://maps.app.goo.gl/8nvgJfohiiRPmbzL8' },
  { id: 'yelp', label: 'Yelp', href: 'https://yelp.com/biz/go4profit-llc-chicago' },
  { id: 'linkedin', label: 'LinkedIn', href: 'https://www.linkedin.com/company/go4profit' },
  { id: 'facebook', label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=100090558631045' },
];

export const SEO = {
  home: {
    title: 'Bookkeeping & Accounting for Small Businesses | Go4Profit',
    description:
      'Monthly bookkeeping, payroll, tax preparation, and advisory for small businesses. Clear pricing, agreed before work begins.',
    path: '/',
    crumb: 'Home',
  },
  services: {
    title: 'Bookkeeping, Payroll & Tax Services | Go4Profit',
    description:
      'From everyday tasks to bigger decisions, our team helps you stay organized and plan ahead.',
    path: '/services',
    crumb: 'Services',
  },
  platform: {
    title: 'Your Accounting Client Portal | Go4Profit',
    description:
      'View financials, share documents, track deadlines, and connect with your team in one simple portal.',
    path: '/platform',
    crumb: 'Our platform',
  },
  pricing: {
    title: 'Bookkeeping From $350/Month | Go4Profit',
    description:
      'Explore Go4Profit pricing for bookkeeping, cleanup, payroll, tax preparation, and advisory. Clear quotes agreed before work begins.',
    path: '/pricing',
    crumb: 'Pricing',
  },
  about: {
    title: 'About Our Accounting Team | Go4Profit',
    description:
      'Go4Profit combines an experienced team with AI-powered technology to make accounting simpler for small businesses and startups.',
    path: '/about',
    crumb: 'About',
  },
  courses: {
    title: 'Bookkeeping Courses with Ainur | Go4Profit',
    description:
      'Practical bookkeeping courses with Ainur through Synoro Academy for beginners, owners, and aspiring bookkeepers.',
    path: '/courses',
    crumb: 'Courses',
  },
  contact: {
    title: 'Contact Go4Profit',
    description:
      'Questions about bookkeeping, payroll, or tax? Email info@go4profit.us or book a free consultation.',
    path: '/contact',
    crumb: 'Contact',
  },
  book: {
    title: 'Book a Free Accounting Consultation | Go4Profit',
    description:
      'Choose a time for a free 30-minute call. We’ll discuss your needs, answer your questions, and explain pricing.',
    path: '/book',
    crumb: 'Book a consultation',
  },
  getStarted: {
    title: 'Accounting Support for Small Businesses | Go4Profit',
    description:
      'Get organized books, clear reports, and a team that makes time for your questions. Book a free 30-minute consultation. Bookkeeping from $350/month.',
    path: '/get-started',
    crumb: 'Get started',
  },
  trucking: {
    title: 'Bookkeeping for Trucking Businesses | Go4Profit',
    description:
      'Organized books, clear reports, and a team that understands trucking. Book a free consultation. Monthly bookkeeping from $350/month.',
    path: '/trucking',
    crumb: 'Trucking',
  },
  bookkeeping: {
    title: 'Monthly Bookkeeping from $350 | Go4Profit',
    description:
      'Ongoing bookkeeping from $350 a month, including reports and support. Catch-up and cleanup are quoted separately.',
    path: '/bookkeeping',
    crumb: 'Bookkeeping',
  },
  notFound: {
    title: 'Page not found | Go4Profit',
    description: 'This Go4Profit page is missing. Return home or book a free consultation.',
    path: '/',
    robots: 'noindex, follow',
  },
  privacy: {
    title: 'Privacy Policy | Go4Profit',
    description:
      'How Go4Profit collects, uses, and protects personal and business information for website visitors, consultations, and accounting clients.',
    path: '/privacy',
    crumb: 'Privacy Policy',
  },
  terms: {
    title: 'Terms of Service | Go4Profit',
    description:
      'Terms of Service for the Go4Profit website, consultations, and accounting and advisory services.',
    path: '/terms',
    crumb: 'Terms of Service',
  },
  blog: {
    title: 'Clear Answers for Your Business | Go4Profit',
    description:
      'Practical advice on bookkeeping, cash flow, taxes, and smarter ways to manage your accounting.',
    path: '/blog',
    crumb: 'Blog',
  },
};

export const LEGAL_UPDATED = 'October 2, 2026';

export const NAV_LINKS = [
  { to: '/services', label: 'Services' },
  { to: '/platform', label: 'Our platform' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/blog', label: 'Blog' },
  { to: '/about', label: 'About us' },
];

export const HOME_POINTS = [
  { icon: 'reports', label: 'Accurate books. On-time reports.', short: 'Accurate books' },
  { icon: 'chat', label: 'Great customer support', short: 'Great support' },
  { icon: 'pin', label: 'Chicago-based. Serving nationwide.', short: 'Chicago' },
];

export const HOME_SERVICES = [
  {
    slug: 'bookkeeping',
    icon: 'ledger',
    title: 'Bookkeeping',
    items: [
      'Transaction categorization & reconciliation in QuickBooks',
      'Monthly profit and loss statement and balance sheet',
      'Dedicated bookkeeper and ongoing support',
    ],
  },
  {
    slug: 'payroll',
    icon: 'payroll',
    title: 'Payroll',
    items: [
      'Payroll setup and processing',
      'Employee and contractor payments',
      'Organized payroll records',
    ],
  },
  {
    slug: 'tax',
    icon: 'tax',
    title: 'Individual & business tax',
    items: [
      'Individual tax return preparation',
      'Business tax return preparation',
      'Federal and state filing',
    ],
  },
  {
    slug: 'advisory',
    icon: 'advisory',
    title: 'Business advisory & AI tools',
    items: [
      'Cash flow, profitability, and financial planning',
      'Custom metrics and AI dashboards',
      'Automation for routine tasks and reports',
    ],
  },
];

export const HOME_EXPERIENCE = {
  portalTitle: 'All your companies, documents, and deadlines - in one place.',
  body: 'We use AI to reduce repetitive work, giving our team more time to support your business. View financials, share documents, and track progress - so you know where your books stand and what’s next.',
};

export const HOME_CLOSE_BENEFITS = [
  {
    icon: 'invoices',
    title: 'Clear pricing',
    body: 'See all charges upfront. No hidden fees. Cancel anytime.',
  },
  {
    icon: 'support',
    title: 'Responsive support',
    body: 'We’re always available for your questions Mon–Fri, 9 AM–5 PM Central Time.',
  },
  {
    icon: 'reports',
    title: 'Reports & portal access',
    body: 'Weekly and monthly reports. Access your financials anytime.',
  },
  {
    icon: 'review',
    title: 'Experienced Professionals + AI',
    body: 'Our team focuses on your business while AI handles routine manual work.',
  },
  {
    icon: 'advisory',
    title: 'Insights for your business',
    body: 'Understand your cash flow, spot rising costs, and plan ahead.',
  },
  {
    icon: 'pin',
    title: 'Nationwide service',
    body: 'Chicago-based. Serving businesses across the USA.',
  },
];

export const HOME_STEPS = [
  {
    icon: 'calendar',
    title: 'Book a free consultation',
    body: 'Tell us about your business and what you need.',
  },
  {
    icon: 'invoices',
    title: 'Sign your agreement',
    body: 'Confirm services and pricing, then share access and documents.',
  },
  {
    icon: 'review',
    title: 'We take it from here',
    body: 'Our team gets to work and keeps you updated.',
  },
];

export const CLIENT_NAMES = [
  'Sultan Trans',
  'JTI',
  'Manas Express',
  'Northline Logistics',
  'Harbor Peak',
  'Elm & Oak',
  'Bluebird Goods',
  'Cedar Ridge',
  'Lakeside Supply',
  'Westfield Partners',
  'Prairie Goods',
  'Ironwood Co.',
];

export const TESTIMONIALS = [
  {
    name: 'Sultan Trans',
    quote:
      'When Go4Profit came in, our books were pretty messy and needed a lot of cleanup. They went back, fixed the issues, got everything reconciled, and put a proper process in place. Since then, they\'ve been handling our monthly bookkeeping and everything has been much more organized.',
  },
  {
    name: 'JTI',
    quote:
      'What I like about Go4Profit is that they don\'t just send us financial statements and move on. They help us understand the numbers behind the business — cost per mile, revenue per mile, cash flow, and profitability. It gives us a much better idea of where we\'re doing well and where we need to improve.',
  },
  {
    name: 'Manas Express',
    quote:
      'Go4Profit has made the accounting side of our business much easier. Our books are kept up to date, the monthly reports are clear, and when we have questions, their team is easy to reach. It\'s nice to actually know where the business stands financially each month.',
  },
  {
    name: 'Renee Alvarez',
    quote:
      'Our books were pretty messy when we started. We had transactions we weren’t sure about and accounts that hadn’t been reconciled. The team worked through the backlog and asked us questions when something needed clarification. Now they handle the monthly bookkeeping, and we have a much better routine for sending documents and keeping everything organized.',
  },
  {
    name: 'Marcus Hill',
    quote:
      'I used to leave the bookkeeping until I had some free time, which usually meant it kept getting pushed back. Having someone take care of it every month has helped a lot. We still need to send documents and answer questions, but I’m no longer spending my weekends trying to catch up on everything.',
  },
  {
    name: 'Sofia Patel',
    quote:
      'Before, I would mostly look at the bank balance to see how we were doing. I wasn’t getting much out of the financial reports because I didn’t really understand them. Being able to go through the numbers and ask questions has made them more useful. I have a clearer picture of our expenses and what’s left after everything is paid.',
  },
  {
    name: 'Hannah Brooks',
    quote:
      'The communication has been the biggest thing for me. If there’s a transaction they don’t recognize, they ask instead of guessing. And when I have a question, I can get an explanation without feeling like I need an accounting background. It’s made the whole process easier to keep up with.',
  },
  {
    name: 'Derek Walsh',
    quote:
      'We already knew our gross revenue and rate per mile, but that didn’t tell us how much we were actually keeping. Looking at fuel, repairs, driver pay, and the other costs together helped us understand the business better. There are still things we’re working on, but now we have a clearer idea of which questions to ask and where to pay attention.',
  },
];

export const SERVICE_SECTIONS = [
  {
    id: 'bookkeeping',
    icon: 'ledger',
    title: 'Bookkeeping',
    subtitle: 'Organized books. Numbers you can understand.',
    intro:
      'We keep your QuickBooks records up to date so you can see what your business earns, spends, and keeps.',
    listLabel: 'What’s included',
    items: [
      'Categorized transactions in QuickBooks',
      'Reconciled bank and credit card accounts',
      'Account categories organized for your business',
      'Profit and loss statements and balance sheets',
      'A dedicated bookkeeper for questions and ongoing support',
      'Portal access to your reports, documents, and requests',
    ],
    notes: [
      'Reports are provided weekly or monthly, depending on your service plan. We follow up on missing information and explain anything you have questions about.',
      'Already using QuickBooks? We can work with your existing account or help you get set up.',
    ],
  },
  {
    id: 'cleanup',
    icon: 'cleanup',
    title: 'Catch-up & cleanup',
    subtitle: 'Behind on your books? We’ll help you catch up.',
    intro: 'We bring overdue records up to date and correct existing bookkeeping issues.',
    listLabel: 'What’s included',
    items: [
      'A review of your existing books',
      'Missing transactions recorded',
      'Duplicate entries and bookkeeping errors corrected',
      'Bank and credit card accounts reconciled',
      'Updated financial reports for the agreed period',
      'A list of any unresolved items that need your input',
    ],
    notes: [
      'You receive a quote and estimated timeline before work begins. Once cleanup is complete, you can move into ongoing bookkeeping.',
    ],
  },
  {
    id: 'payroll',
    icon: 'payroll',
    title: 'Payroll',
    subtitle: 'Your team paid. Your records organized.',
    intro:
      'We help set up and process payroll, track payments, and keep payroll activity connected to your books.',
    listLabel: 'What’s included',
    items: [
      'Payroll setup and processing',
      'Employee and contractor payment support',
      'Organized payroll records',
      'Payroll reports and entries in QuickBooks',
    ],
    notes: [
      'You provide hours, pay details, and approval. Our team handles the agreed payroll tasks on your payment schedule.',
    ],
  },
  {
    id: 'tax',
    icon: 'tax',
    title: 'Individual & business tax',
    subtitle: 'Help preparing and filing your returns.',
    intro:
      'We organize your tax information, prepare the agreed returns, and guide you through review and filing.',
    listLabel: 'What’s included',
    items: [
      'Individual tax return preparation',
      'Business tax return preparation',
      'Federal and state filing for the agreed returns',
      'A document checklist and follow-up on missing information',
      'Copies of your completed returns',
    ],
    notes: [
      'We confirm the return types, tax years, states, and fees before starting. You review and approve your returns before filing.',
      'Bookkeeping cleanup is quoted separately if your records need work before tax preparation.',
    ],
  },
  {
    id: 'advisory',
    icon: 'advisory',
    title: 'Business advisory',
    subtitle: 'Understand your numbers. Plan ahead.',
    intro: 'Get practical guidance on your cash flow, expenses, and profitability.',
    listLabel: 'What’s included',
    items: [
      'Cash flow review and forecasting',
      'Expense and profitability analysis',
      'Budgeting and financial planning',
      'Guidance on pricing, hiring, and growth',
    ],
    notes: ['We explain your numbers and help you turn them into a plan.'],
  },
  {
    id: 'ai-tools',
    icon: 'aiassist',
    title: 'Custom AI tools & dashboards',
    subtitle: 'Built around your business.',
    intro: 'Track the metrics that matter and reduce repetitive work with custom tools.',
    listLabel: 'What’s included',
    items: [
      'Custom metrics based on your goals',
      'Dashboards that bring your data together',
      'AI insights into trends and changes',
      'Automation for routine tasks and reports',
    ],
    notes: [
      'Track profit by customer, location, or truck—or other metrics your business needs. We agree on features, data, pricing, and timing before building.',
    ],
  },
];

export const FAQS = [
  {
    question: 'What’s included in the $350 monthly plan?',
    answer:
      'Up to 200 monthly transactions, account reconciliation, monthly financial reports, ongoing support, and a monthly financial review.',
  },
  {
    question: 'What if I have more than 200 transactions?',
    answer: 'We review your transaction volume and provide a quote that fits your business.',
  },
  {
    question: 'Is catch-up or cleanup included?',
    answer: 'No. Catch-up and cleanup are quoted separately based on the periods and work needed.',
  },
  {
    question: 'Are payroll and tax returns included?',
    answer: 'These are separate services. We confirm their pricing before adding them to your plan.',
  },
  {
    question: 'Are there any additional fees?',
    answer: 'Your quote lists any setup, cleanup, software, or third-party fees upfront.',
  },
  {
    question: 'Can I keep my existing QuickBooks account?',
    answer:
      'Yes. We can work in your existing QuickBooks Online account. Any subscription fees are explained in your quote.',
  },
  {
    question: 'Can my monthly price change?',
    answer:
      'We review pricing quarterly. Your fee may increase or decrease as your transaction volume changes.',
  },
  {
    question: 'Do I need to sign an annual contract?',
    answer:
      'No annual contract is required. You can cancel according to the cancellation terms in your agreement.',
  },
  {
    question: 'Can you support more than one company?',
    answer:
      'Yes. We agree on pricing for each company, and you can keep track of them through one portal.',
  },
  {
    question: 'What do you need to give me a quote?',
    answer:
      'Tell us about your business, the services you need, and whether your books are up to date. We may request recent statements to understand the work involved.',
  },
  {
    question: 'How do I get started?',
    answer:
      'Book a free consultation. We’ll discuss your needs, provide a quote, and help you get set up after you sign your agreement.',
  },
];

export const PLATFORM_FEATURES = [
  {
    title: 'See how your business is doing.',
    body: 'View revenue, expenses, profit, and the financial reports our team prepares for you.',
  },
  {
    title: 'Upload and find documents.',
    body: 'Share statements, receipts, and other records. Keep your reports and important documents easy to find.',
  },
  {
    title: 'Answer questions about transactions.',
    body: 'See exactly which payment needs clarification, add a quick explanation, or attach a receipt.',
  },
  {
    title: 'Stay on top of your accounting.',
    body: 'Track progress across your companies, see upcoming deadlines, and know what needs your attention.',
  },
  {
    title: 'Keep track of billing.',
    body: 'View your services, upcoming invoices, and payment history with Go4Profit.',
  },
  {
    title: 'Stay connected with your team.',
    body: 'Ask questions and keep conversations about your accounting in one place.',
  },
];

export const PRICING_OFFERS = [
  {
    icon: 'ledger',
    title: 'Monthly bookkeeping',
    price: 'From $350/month',
    body: 'Transactions categorized, accounts reconciled, and monthly reports prepared - with ongoing support and a monthly financial review.',
    note: 'Includes up to 200 transactions per month.',
    featured: true,
  },
  {
    icon: 'cleanup',
    title: 'Catch-up & cleanup',
    price: 'Custom quote',
    body: 'Bring overdue books up to date, correct errors, and get updated financial reports.',
  },
  {
    icon: 'tax',
    title: 'Individual & business tax',
    price: 'Business from $450, Personal: custom quote',
    body: 'Preparation and filing for your personal and business tax returns.',
  },
  {
    icon: 'payroll',
    title: 'Payroll',
    price: 'Custom quote',
    body: 'Payroll setup, processing, and reporting based on your team’s needs.',
  },
  {
    icon: 'advisory',
    title: 'Business advisory & CFO support',
    price: 'Custom quote',
    body: 'Support with cash flow, profitability, budgeting, and planning your next steps.',
  },
  {
    icon: 'aiassist',
    title: 'Custom AI tools & dashboards',
    price: 'Custom quote',
    body: 'Tools built around your business to track performance and reduce manual work.',
  },
];

export const PRICING_FACTORS = [
  'Monthly transaction volume',
  'Number of business entities',
  'Number of bank and credit card accounts',
  'Complexity of your accounting and reporting',
  'Condition and organization of your records',
  'Services and level of support you need',
];

export const BOOK_SERVICES = [
  { value: '', label: 'What do you need help with?' },
  { value: 'monthly', label: 'Monthly bookkeeping' },
  { value: 'cleanup', label: 'Catch-up & cleanup' },
  { value: 'payroll', label: 'Payroll' },
  { value: 'tax', label: 'Tax preparation' },
  { value: 'advisory', label: 'Advisory' },
  { value: 'unsure', label: 'Not sure yet' },
];

export const LANDING_DELIVERABLES = [
  'Organized transactions',
  'Reconciled bank and credit card accounts',
  'Monthly financial reports',
  'Support with bookkeeping questions',
];

export const LANDING_STEPS = [
  'Free consultation',
  'Agreed scope and pricing',
  'Onboarding',
  'Ongoing bookkeeping and reports',
];

export const COURSE_SKILLS = [
  'Bookkeeping fundamentals',
  'QuickBooks Online',
  'Categorizing transactions',
  'Bank and credit card reconciliation',
  'Reading financial reports',
  'Month-end bookkeeping',
];

export const COURSES = [
  {
    title: 'Professional Bookkeeping',
    href: COURSES_URL,
    summary:
      'Build your understanding of bookkeeping, financial statements, and accounting software through practical lessons.',
  },
];

export const FOUNDER_VIDEO_SCRIPT =
  'Hi, I’m Ainur, founder of Go4Profit. If bookkeeping keeps getting pushed back, we can help. Our team organizes your transactions, reconciles your accounts, and prepares your financial reports. We use AI to reduce repetitive work, and our team reviews the details and answers your questions. Whether you need to catch up or want ongoing monthly support, book a free consultation and let’s talk about your business.';

export const FOOTER_SERVICES = [
  { to: '/services#bookkeeping', label: 'Bookkeeping' },
  { to: '/services#payroll', label: 'Payroll' },
  { to: '/services#tax', label: 'Individual & business tax' },
  { to: '/services#advisory', label: 'Business advisory' },
  { to: '/services#ai-tools', label: 'Custom AI tools & dashboards' },
  { to: '/services#cleanup', label: 'Catch-up & cleanup' },
];

export const FOOTER_COMPANY = [
  { to: '/about', label: 'About' },
  { to: '/platform', label: 'Our platform' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/blog', label: 'Blog' },
  { to: '/contact', label: 'Contact' },
];

export const INQUIRY_SERVICES = BOOK_SERVICES;
